import store from '@/store'
import { sample, uniqid } from '@/js/utils'
import data_cards from '@/data/data_cards'
import data_rooms from '@/data/data_rooms'


export const generate_level = (data = {}) => {
	const cards = []


	for (var i = 0; i < 3; i++) {
		let room = i === 2 ? sample(data_rooms['boss']) : sample(data_rooms['classic'])
		if (data.tuto && i === 0) room = sample(data_rooms['tuto'])
		room.forEach((slot, position) => {
			if (slot) {
				let card = null
				const type = slot.substr(0, 1)
				const level = parseInt(slot.substr(1, 1)) - 1
				
				if (type === 'E') card = generate_card({ type: 'enemy', boss: false, level })
				else if (type === 'B') card = generate_card({ type: 'enemy', boss: true, level })
				else if (type === 'W') card = generate_card({ type: 'weapon', level })
				else if (type === 'S') card = generate_card({ type: 'shield', level })
				else if (type === 'G') card = generate_card({ type: 'gold', level })
				else if (type === 'I') card = generate_card({ type: 'item', level })
				else if (type === 'T') card = generate_card({ type: 'trap', level })
				
				if (card) {
					card.position = position + (7 * i)
					card.room = Math.floor(card.position / 7)
					cards.push(card)
				}
			}
		})
	}

	return cards
}


export const generate_hero = (data = {}) => {
	return generate_card({ slug: data.slug, position: 0 })
}


export const generate_talisman = (data = {}) => {
	// return generate_card({ slug: data.slug, position: 0 })
	return { 
		...sample(data_cards.filter(t => t.type === 'talisman' && t.slug === data.slug)),
		id: uniqid()
	}
}


export const generate_card = (data = {}) => {
	let card = {}
	if (data.slug) {
		card = { 
			...data_cards.find(c => c.slug === data.slug),
			...data,
			id: uniqid(),
			animation: 'idle'
		}
	}
	else if (data.type) {
		const cards = data.boss ? data_cards.filter(c => c.type === data.type && c.boss) : data_cards.filter(c => c.type === data.type && !c.boss)
		card = { 
			...sample(cards),
			...data,
			id: uniqid(),
			animation: 'idle'
		}

	}
	if (card) {
		if (card.levels) {
			const level = data.level !== undefined ? card.levels[data.level] : sample(card.levels)
			card = { ...card, ...level }
			delete card.levels
			delete card.level
		}
		if (card.talismans) {
			let talismans = []
			card.talismans.forEach((slug) => {
				talismans.push(generate_talisman({ slug }))
			})
			card.talismans = talismans
		}
		if (card.type === 'enemy' || card.type === 'hero') {
			card.life_max = card.life
			card.equipments = []
			if (!card.talismans) card.talismans = []
			card.status = []
		}
	}
	return card
}





export const get_attack_damage = (data = {})  => {
	const values = {}
	if (data.attacker && data.victim) {
		const damage = get_card_value(data.attacker, 'attack') - get_card_value(data.victim, 'armor')
		if (damage > 0) values.life = get_card_value(data.victim, 'life') - damage
	}
	return values
}





export const get_card_value = (card, type) => {
	if (!type) console.error('undefined get_card_value type:', card.type)
	if (card && type && card[type] !== undefined) {
		let modifier = 0

		if (card.type === 'hero') {
			modifier = type === 'life_max' ? store.getters.hero_modifiers['life'] : store.getters.hero_modifiers[type]
		} else if (card.type === 'enemy') {
			modifier = type === 'life_max' ? store.getters.card_modifiers['enemy_life'] : store.getters.card_modifiers['enemy_' + type]
		} else if (card.type === 'weapon') {
			modifier = store.getters.card_modifiers['weapon_' + type]
		} else if (card.type === 'shield') {
			modifier = store.getters.card_modifiers['shield_' + type]
		} else {
			modifier = store.getters.card_modifiers[type] ? store.getters.card_modifiers[type] : 0
		}

		let value = card[type] ? card[type] + modifier : modifier

		if (card.status && type === 'attack' && card.status.find(s => s.slug === 'strength')) value++
		if (card.status && type === 'attack' && value > 1 && card.status.find(s => s.slug === 'weakness')) value--

		// MINIMUM VALUES
		if (card.type === 'hero' || card.type === 'enemy') {
			if (type === 'attack' && value < 1) value = 1
		}
		if (type === 'price' && value < 1) value = 1

		return value
	}
	return 0
}


export const get_card_value_type = (card) => {
	if (card.slug === 'health-potion') return 'life'
	if (card.slug === 'poison-potion') return 'poison'
	if (card.slug === 'strength-potion') return 'strength'
	if (card.slug === 'weakness-potion') return 'weakness'
	if (card.type === 'shield') return 'armor'
	if (card.type === 'weapon') return 'attack'
	return card.type
}
